<div class="navbar-nav mr-auto mt-2 mt-lg-0">
  <app-nav-link *ngFor="let link of links" path="{{link.path}}" name="{{link.name}}" class="mt-2 mt-lg-0 mr-5"></app-nav-link>
  <a class="text-decoration-none text-dark mt-3 mt-lg-0 mr-5" href="https://usacycling.org/events" target="_blank">Events Search</a>
  <a class="text-decoration-none text-dark mt-3 mt-lg-0 mr-5" href="https://www.usacycling.org/user-login">My Account</a>
  <span> {{firstName}} {{lastName}} </span>
  <a (click)="logout()" class="text-decoration-none text-dark mt-3 mt-lg-0 mr-5" style="cursor: pointer;">Sign Out</a>
  <a (click)="closeCart()" class="mt-3 mt-lg-0 cart-link text-decoration-none text-dark"><i class="icon icon-shopping-cart"></i></a>
</div>
